const getScrollbarSize = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const size = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return size;
};

const viewState = {
    notifications: [],
    organizationId: '', //複数の組織に属している場合のみ使う
    projectId: '',
    size: {
        notificationsHeight: 0,
        scrollbarSize: getScrollbarSize()
    },
    version: {
        current: '',
        old: ''
    },
    isLoading: false,
    isLoadingMain: false
};

const view = {
    namespaced: true,
    state: viewState,
    getters: {
        diffVersion(state) {
            if (state.version.current && state.version.old) {
                let v1 = state.version.current.split('.');
                let v2 = state.version.old.split('.');
                let max = Math.max(v1.length, v2.length);
                for (let i = 0; i < max; i++) {
                    v1[i] = v1[i] || '0';
                    v2[i] = v2[i] || '0';
                    if (v1[i] !== v2[i]) {
                        if (i === 0) {
                            return 'major';
                        } else {
                            return 'minor';
                        }
                    }
                }
            }
            return null;
        },
        maintenance(state) {
            return state.notifications.filter(
                item => item.level === 'maintenance'
            )[0];
        },
        notifications(state) {
            return state.notifications.filter(
                item => item.level !== 'maintenance'
            );
        },
        organization(state, getters, rootState, rootGetters) {
            // 複数の組織に属していない場合
            if (!rootGetters['user/hasOrganizations']) {
                return rootState.user.me.organization;
            }
            const organizations = rootState.user.me.organizations;

            for (let i = 0; i < organizations.length; i++) {
                if (organizations[i].organizationId === state.organizationId) {
                    return organizations[i];
                }
            }
            // 複数の組織に属しているが、まだ組織を選択していない場合
            return {};
        },
        project(state, getters, rootState) {
            const projects = rootState.user.data.projects;
            for (let i = 0; i < projects.length; i++) {
                if (projects[i].id === state.projectId) {
                    return projects[i];
                }
            }
            return {};
        },
        isMaintenance(state) {
            return state.notifications.some(
                item => item.level === 'maintenance'
            );
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.isLoading = payload;
        },
        setLoadingMain(state, payload) {
            state.isLoadingMain = payload;
        },
        setNotifications(state, payload) {
            if (payload && Array.isArray(payload)) {
                state.notifications = payload;
            }
        },
        setOrganizationId(state, payload) {
            state.organizationId = payload ? payload : '';
        },
        setProjectId(state, payload) {
            state.projectId = payload ? payload : '';
        },
        setSize(state, payload) {
            Object.assign(state.size, payload);
        },
        setVersion(state, payload) {
            if (payload) {
                if (!state.version.old) {
                    state.version.old = payload;
                }
                state.version.current = payload;
            }
        },
        reset(state) {
            state.notifications = [];
            state.organizationId = '';
            state.projectId = '';
            Object.assign(state.size, viewState.size);
            Object.assign(state.version, viewState.version);
            state.isLoading = false;
            state.isLoadingMain = false;
        }
    },
    actions: {
        setLoading({ commit }, response) {
            commit('setLoading', response);
        },
        setLoadingMain({ commit }, response) {
            commit('setLoadingMain', response);
        },
        setNotifications({ commit }, response) {
            commit('setNotifications', response);
        },
        setOrganizationId({ commit }, response) {
            commit('setOrganizationId', response);
        },
        setProjectId({ commit }, response) {
            commit('setProjectId', response);
        },
        setSize({ commit }, response) {
            commit('setSize', response);
        },
        setVersion({ commit }, response) {
            commit('setVersion', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default view;
